import { Injectable } from "@angular/core";
import { LorenAssetProperty } from "../../interfaces/loren-asset-property.interface";
import { LorenAsset } from "../../interfaces/loren-asset.interface";
import { LorenAssetType } from "../../interfaces/loren-asset-type.interface";
import { LorenMeteringType } from "../../interfaces/loren-metering-type";
import { LorenHostOfAssetModel } from "../../../../shared/modules/loren-dashboard-card/interfaces/loren-host-of-asset.model";
import { LorenMeteringContext } from "../../enums/loren-metering-context.enum";

@Injectable({
  providedIn: "root",
})
export class LorenAssetUtilsService {

  static populateAssetProperties(
    properties: LorenAssetProperty[],
    typeProperties: number[],
    asset: LorenAsset
  ) {
    properties.forEach((x) => {
      if (!typeProperties.includes(x.id)) {
        return;
      }

      const propertyData = asset.propertiesData.find(
        (c) => c.propertyTypeId === x.id
      );
      x.value = propertyData ? propertyData.value : null;
    });

    asset.properties = properties.filter((x) => typeProperties.includes(x.id));
  }

  static getAssetTypeProperties(
    assetTypes: LorenAssetType[],
    asset: LorenAsset
  ) {
    const assetType = assetTypes.find((x) => x.id === asset.typeId);
    return assetType?.properties ?? [];
  }

  static getHostOfAssets(
    assetId: number,
    allAssets: LorenAsset[]
  ): Map<string, LorenHostOfAssetModel[]> {
    const asset = allAssets.find((x) => x.id === assetId);
    const presenceMeteringData = asset.metering.filter(
      (x) => x.type === LorenMeteringType.PRESENCE_SENSOR
    );
    const hostMap = new Map<string, LorenHostOfAssetModel[]>();

    presenceMeteringData.forEach((metering) => {
      const hostOfData = metering.data.filter((x) => x.key === "host_of");
      const models: LorenHostOfAssetModel[] = hostOfData.map((x) => ({
        asset: allAssets.find((a) => a.id === Number(x.value)),
        time: x.time,
      }));

      hostMap.set(
        metering.description,
        models.sort((a, b) => a.asset.id - b.asset.id)
      );
    });

    return hostMap;
  }

  static getBinaryValue(
    meteringType: LorenMeteringType,
    value,
    meteringContext?: LorenMeteringContext
  ) {
    const shouldBeInverted =
      (meteringType === LorenMeteringType.BINARY_SENSOR &&
        meteringContext !== LorenMeteringContext.STATE) ||
      [
        LorenMeteringType.IGNITION_BINARY_SENSOR,
        LorenMeteringType.SMOKE_BINARY_SENSOR,
      ].some((type) => type === meteringType);

    // When the value is string - check for "true"
    // Otherwise assume boolean|undefined
    // If value is undefined, we assume false
    // When undefined we might have to show no data - but this will be done with refactor of metrics :)
    const val = typeof value === "string" ? value === "true" : value;
    return Boolean(shouldBeInverted ? !val : val).toString();
  }
}
